import React, { FunctionComponent, useEffect, useState } from "react";
import { IShelfSegmentAlbum } from "../../../hooks/shelfSegments";
import { LazyImageAspectFit } from "../../LazyImageAspectFit";
import { ImageCache } from "../../../models/ImageCache";
import { StatusCodesHelper } from "../../../models/StatusCodesHelper";
import { useGetImage } from "../../../hooks/images";
import { useTheme } from "@mui/material";
import { AlbumUtilities } from "../../../models/AlbumUtilities";
import { IShelving } from "../../../hooks/shelvings";
import { ImageUtilities } from "../../../models/ImageUtilities";

export const ShelfSegmentAlbumRepresentation: FunctionComponent<
  IShelfSegmentAlbumRepresentationProps
> = ({ shelving, shelfSegmentAlbum, isHighlighted }) => {
  const theme = useTheme();
  const { getImage } = useGetImage();
  const [image, setImage] = useState();
  const genericSpine = new URL("../../../images/generic_spine.png", import.meta.url).href;
  const fetchImage = async () => {
    const spineImage = AlbumUtilities.getSpineImage(shelfSegmentAlbum.album);
    if (!spineImage) return;
    const response = await getImage({
      name: spineImage.uuid,
      width: ImageCache.bigAlbumImageSize,
      height: ImageCache.bigAlbumImageSize
    });
    if (StatusCodesHelper.isSuccessful(response.status)) {
      setImage(response.body);
    }
  };
  useEffect(() => {
    const thumbnail = shelfSegmentAlbum.album.thumbnail;
    if (!thumbnail) setTintColor(undefined);
    const image = new Image();
    image.src = `data:image/png;base64,${thumbnail}`;
    image.onload = function () {
      setTintColor(ImageUtilities.getDominantColor(image));
    };
  }, [shelfSegmentAlbum.album.thumbnail]);
  const [tintColor, setTintColor] = useState<string | undefined>();
  useEffect(() => {
    fetchImage().then();
  }, [shelfSegmentAlbum.album.uuid]);
  return (
    <LazyImageAspectFit
      style={{
        height:
          shelving.orientation == "horizontal"
            ? shelving.everyAlbumHasSameSize
              ? "96%"
              : AlbumUtilities.getShapeRelativeSize(shelfSegmentAlbum.shape)
            : "fit-content",
        width:
          shelving.orientation == "horizontal"
            ? "fit-content"
            : shelving.everyAlbumHasSameSize
              ? "96%"
              : AlbumUtilities.getShapeRelativeSize(shelfSegmentAlbum.shape),
        borderStyle: "solid",
        borderRadius: "4px",
        borderWidth: isHighlighted ? "3px" : "0",
        borderColor: isHighlighted ? theme.palette.colors?.highlightSpine : "transparent",
        pointerEvents: "none"
      }}
      image={image}
      thumbnail={AlbumUtilities.getSpineImage(shelfSegmentAlbum.album)?.thumbnail}
      defaultImage={genericSpine}
      beforeLoad={fetchImage}
      alt={shelfSegmentAlbum.album.name}
      forceVertical={shelving.orientation == "horizontal"}
      forceHorizontal={shelving.orientation == "vertical"}
      tintColor={image !== undefined ? undefined : tintColor}
      waitUntilImageIsFinal
    />
  );
};

export interface IShelfSegmentAlbumRepresentationProps {
  shelving: IShelving;
  shelfSegmentAlbum: IShelfSegmentAlbum;
  isHighlighted: boolean;
}
